import Grid from "../Grid/grid";
import Title from "../title";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "react-device-frameset/styles/marvel-devices.min.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

function ImgSection({ work }: { work: any }) {
  if (!work?.main_image_url) return null;
  const Images = [work?.main_image_url, ...work?.other_images_urls];

  return (
    <section className="relative flex flex-col min-h-screen px-6 sm:px-8 md:px-12 lg:px-20 py-16 overflow-hidden bg-gradient-to-b from-gray-50/30 to-white">
      <Grid size={120} direction="top-center" />

      <div className="z-10 flex mb-20 w-full">
        <Title title="Gallery" />
      </div>

      <div className="w-full flex items-center justify-center relative group">
        <div className="relative w-full max-w-5xl">
          <Swiper
            pagination={{
              clickable: true,
              dynamicBullets: true,
              renderBullet: (index: any, className: any) => {
                return `<span class="${className} !bg-gray-400 !opacity-40 hover:!opacity-80 !w-2 !h-2 !rounded-full transition-all duration-300"></span>`;
              },
            }}
            navigation={{
              nextEl: ".custom-swiper-next",
              prevEl: ".custom-swiper-prev",
            }}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={Images.length > 1}
            modules={[Pagination, Navigation, Autoplay]}
            className="relative w-full rounded-2xl overflow-hidden shadow-2xl shadow-gray-200/50"
            style={
              {
                "--swiper-pagination-bottom": "24px",
                "--swiper-pagination-bullet-inactive-color": "#9CA3AF",
                "--swiper-pagination-bullet-inactive-opacity": "0.4",
              } as React.CSSProperties
            }
          >
            {Images.map((data: string, index: number) => (
              <SwiperSlide
                key={index}
                className="flex items-center justify-center bg-white relative overflow-hidden"
              >
                <div className="relative w-full h-40 md:h-[500px] lg:h-[550px]">
                  <img
                    className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-[1.02]"
                    src={data}
                    alt={`Project showcase ${index + 1}`}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent pointer-events-none"></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {Images.length > 1 && (
            <>
              <button className="custom-swiper-prev absolute left-6 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-20 opacity-0 group-hover:opacity-100 hover:scale-110 flex items-center justify-center border border-gray-200/50">
                <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
              </button>

              <button className="custom-swiper-next absolute right-6 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-20 opacity-0 group-hover:opacity-100 hover:scale-110 flex items-center justify-center border border-gray-200/50">
                <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
              </button>
            </>
          )}
        </div>
      </div>

      <div className="flex justify-center mt-12">
        <div className="text-xs text-gray-400 font-light tracking-wider">
          Swipe or use arrow keys to navigate
        </div>
      </div>
    </section>
  );
}

export default ImgSection;
